module.exports = __webpack_public_path__ + "img/rectangle-border-lg.ac6bed53.svg";